import { writable } from 'svelte/store';
import { getTolgeeContext } from './index';
export const getLanguageStore = () => {
    const context = getTolgeeContext();
    const store = writable(context.tolgee.lang);
    context.tolgee.onLangChange.subscribe((lang) => {
        store.set(lang);
    });
    store.subscribe((lang) => {
        context.tolgee.changeLanguage(lang);
    });
    return store;
};
